import * as ContextMenu from "@radix-ui/react-context-menu";
import type { ReactNode } from "react";

import { FileManagerBodyDefaultMenuItems } from "./FileManagerBodyMenuItems";

import styles from "./FileManagerContextMenu.module.scss";

interface FileManagerBodyContextMenuProps {
  children: ReactNode;
  menuContent?: ReactNode;
}

export function FileManagerBodyContextMenu({
  children,
  menuContent,
}: FileManagerBodyContextMenuProps) {
  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger asChild>
        <div style={{ display: "contents" }}>{children}</div>
      </ContextMenu.Trigger>
      <ContextMenu.Portal>
        <ContextMenu.Content className={styles.content}>
          {menuContent ?? <FileManagerBodyDefaultMenuItems />}
        </ContextMenu.Content>
      </ContextMenu.Portal>
    </ContextMenu.Root>
  );
}
